// Flujo financiero canónico de un aseo para Aloja Fácil Empresa.
//
// Fuente de verdad: docs/flujo-financiero.md §6.5. Un aseo lleva UN solo
// campo de flujo (`pagado_por.tipo`) y 4 subítems; los destinatarios son
// implícitos: el aseador asignado siempre recibe `pago_aseador`, la
// lavandería asociada siempre recibe `lavandería`, y AF retiene o egresa
// `transporte`+`materiales` según quién ponga el dinero.
//
//   tipo 0 (AF paga):       egreso AF = pago_aseador + transporte + materiales + lavandería ; ingreso = 0
//   tipo 1 (Cliente paga):  ingreso AF = transporte + materiales ; egreso = 0
//   tipo 2 (Arrendatario):  ingreso AF = transporte + materiales ; egreso = 0
//
// Cuando paga un externo (tipo 1/2), `pago_aseador` y `lavandería` son
// pass-through (entran y salen por el mismo monto) → no aportan a la caja AF.
//
// Este es el ÚNICO lugar donde vive la regla del flujo del aseo. Deben
// consumirlo todos los cálculos de AF (Resumen de /finanzas-empresa, pestaña
// Aseos, gráficos de /estadisticas-admin) para que NUNCA diverjan. Round
// 2026-06-18 (fix P1 del tracker docs/pendientes-finanzas-estadisticas.md).

export interface AseoFlujoInput {
  /** `pagado_por` del aseo (0=AF, 1=Cliente, 2=Arrendatario). */
  pagadoPor?: { tipo?: number | null } | null;
  /** Subítems pre-resueltos backend-side (override del aseo o de la propiedad). */
  pagoAseadorSubitem?: number | null;
  transporteSubitem?: number | null;
  materialesSubitem?: number | null;
  lavanderiaSubitem?: number | null;
}

const num = (v: unknown): number => Number(v ?? 0) || 0;

/**
 * Ingreso / egreso de AF Empresa para un aseo, según la regla §6.5.
 * `pagado_por.tipo` desconocido → AF no participa (0/0).
 */
export function flujoAseoAF(aseo: AseoFlujoInput | null | undefined): {
  ingreso: number;
  egreso: number;
} {
  const tipo = aseo?.pagadoPor?.tipo;
  const pagoAseador = num(aseo?.pagoAseadorSubitem);
  const transporte = num(aseo?.transporteSubitem);
  const materiales = num(aseo?.materialesSubitem);
  const lavanderia = num(aseo?.lavanderiaSubitem);

  if (tipo === 0) {
    // AF paga de su caja: egresa los 4 subítems.
    return { ingreso: 0, egreso: pagoAseador + transporte + materiales + lavanderia };
  }
  if (tipo === 1 || tipo === 2) {
    // Paga el cliente o el arrendatario: AF solo retiene transporte + materiales.
    return { ingreso: transporte + materiales, egreso: 0 };
  }
  // Sin pagador reconocido: AF no participa.
  return { ingreso: 0, egreso: 0 };
}
